import React, { useEffect } from "react";
import Navbar from "./navbar";
import Projects from "./sections/projects";
import Footer from "./sections/footer";
import SEO from "../components/SEO";

export default function AllProjectsPage() {
  useEffect(() => {
    // Scroll to top when the page loads
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="m-0 p-0 bg-white">
      <SEO 
        title="Portfolio Projects"
        description="Explore my collection of web development and design projects. From SaaS platforms to interactive web experiences."
      />
      <Navbar />
      <div className="pt-20"> {/* Add padding for fixed navbar */}
        <Projects isFullPage={true} />
      </div>
      <Footer />
    </div>
  );
}
